import { call, put, all, fork, takeLatest } from "redux-saga/effects";
import * as Actions from "./actions";
import * as Api from "./api";
import { CrawlFetchAction } from "./types";
import { CRAWL_FETCH } from "./constants";

export function* crawlFetchWorker(action: CrawlFetchAction) {
  // Mark the crawl as in flight before the request, so link previews wait for
  // it instead of firing again on every keystroke.
  yield put(Actions.crawlFetching({ status: true }));
  try {
    const data = yield call(Api.crawlFetch, action.payload.url);
    const payload = {
      url: String(action.payload.url),
      title: String(data?.title),
      subTitle: String(data?.subTitle),
      durationInSeconds: data?.durationInSeconds,
      link: String(data?.link),
      description: String(data?.description),
      previewUrl:
        data && data.previews && data.previews.edges[0] && String((data.previews.edges[0] as any).preview?.link),
    };
    yield put(Actions.crawlFulfilled(payload));
  } catch (error) {
    const payload = {
      url: String(action.payload.url),
      message: error,
    };
    yield put(Actions.crawlFulfilled(payload));
  } finally {
    // Also runs when a newer URL cancels this crawl.
    yield put(Actions.crawlFetching({ status: false }));
  }
}

export function* watchCrawlFetch() {
  // The newest URL wins. The old take/call loop dropped every URL sent while a
  // crawl was running, so a link typed character by character was never
  // crawled in full and its preview stayed on the loading dots.
  yield takeLatest(CRAWL_FETCH, crawlFetchWorker);
}

const sagas = [watchCrawlFetch];
export default function* root() {
  yield all(sagas.map((saga) => fork(saga)));
}
